import React, { FC, HTMLProps } from 'react'
import { StyledContainer } from './Container.styles'

export const Container: FC<Omit<HTMLProps<HTMLDivElement>, 'ref' | 'type' | 'as'>> = ({ ...props }) => (
  <StyledContainer {...props} />
)
